import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

/* AuthCallback — processes #session_id=... fragment exactly once. */
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await exchangeSession(sessionId);
        await refresh();
        // Strip the hash from URL
        window.history.replaceState(null, "", "/");
        const u = data?.user || {};
        const step = u.onboarding_step || "role";
        if (u.is_admin) {
          navigate("/admin", { replace: true });
        } else if (!u.role || step === "role") {
          navigate("/onboarding/role", { replace: true });
        } else if (u.role === "candidate" && step === "profile") {
          navigate("/onboarding/profile", { replace: true });
        } else if (u.role === "company" && step === "company") {
          navigate("/company/onboarding", { replace: true });
        } else if (u.role === "company") {
          navigate("/company", { replace: true });
        } else {
          navigate("/app", { replace: true });
        }
      } catch (e) {
        setError(
          e?.response?.data?.detail || "Could not complete sign-in. Please try again."
        );
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
      <div className="text-center">
        <div className="font-display text-3xl">Signing you in…</div>
        <p className="overline mt-3">Setting up your Wishire workspace</p>
        {error && (
          <p className="mt-6 text-red-700 max-w-md mx-auto">{error}</p>
        )}
      </div>
    </div>
  );
}
